import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';



import * as moment from 'moment';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

import { CommonService } from './common.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ReportDownloadService } from './report.download.service';
import { BindComponentService } from '../utils/bind.component.service';
/**
 * @author Wesley Mascarenhas
 * @version $Id: reports.operations.service.ts 81701 2018-03-08 23:46:04Z thiago.h.neri $
 */
@Injectable()
export class OperationsReportService extends CommonService  {

  private localURL: string;
  private REPORTS_DOWNLOAD_PATH:string = '/datapackreportsdownload';
  private REPORTS_PATH:string = '/datapackreports';
  private localDownloadURL:string;

  constructor(public http: Http,public modalService: NgbModal,public bindComponent: BindComponentService, public reportDownloadService: ReportDownloadService) {
    super(http, modalService, bindComponent);
    this.localURL = this.baseURL + this.REPORTS_PATH;
    this.localDownloadURL = this.baseURL + this.REPORTS_DOWNLOAD_PATH;
  }

  public listOperationCategories() {
    let url = this.localURL + '?action=listOperationCategories';
    return this.convertResponse(this.httpGet(url));
  }

  public listOperationEvents(categoryId: string, startDate: Date, endDate: Date, startRow: number, fetchSize: number) {
    let url = this.localURL + '?action=listOperationEvents';
    url += '&categoryId=' + categoryId;
    url += '&startDate=' + startDate.getTime();
    url += '&endDate=' + endDate.getTime();
    if (startRow >= 0) {
      url += '&startRow=' + startRow;
    }
    if (fetchSize >= 0) {
      url += '&fetchSize=' + fetchSize;
    }
    return this.convertResponse(this.httpGet(url));
  }

  public generateReport(categoryId: string, categoryName: string, startDate: Date, endDate: Date, startRow: number, fetchSize: number) {
    let url = this.localDownloadURL + '?action=listOperationEvents';
    url += '&categoryId=' + categoryId;
    url += '&categoryName=' + categoryName;
    url += '&startDate=' + startDate.getTime();
    url += '&endDate=' + endDate.getTime();
    if (startRow >= 0) {
      url += '&startRow=' + startRow;
    }
    if (fetchSize >= 0) {
      url += '&fetchSize=' + fetchSize;
    }
    this.reportDownloadService.prepare(url);
  }

}


// WEBPACK FOOTER //
// ./src/app/services/reports.operations.service.ts